import {
  SendTasksRemindersDocument,
  SendTasksRemindersMutation,
  SendTasksRemindersMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useSendProcessTaskReminder = () => {
  const [sendReminders, { loading }] = useMutation(SendTasksRemindersDocument, {
    extractorFn: (data: SendTasksRemindersMutation) =>
      data.tasksMutations.sendRemindersTasksMaterializedProcessTask,
  })

  return {
    loading,
    sendTaskReminders(variables: SendTasksRemindersMutationVariables) {
      return sendReminders({
        variables,
      })
    },
  }
}
